import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'
import { StructureDtoRedux } from '@/store/modules/node'
import { NativeMap } from '@/utils/collections'

export const getBreadcrumbs = (
	node: StructureDto | null,
	nodes: NativeMap<StructureDtoRedux>,
	acc: StructureDto[] = [],
): StructureDto[] => {
	if (!node || !node.parentStructureId) {
		return acc
	}

	const parentNode = nodes[node.parentStructureId]

	if (parentNode) {
		getBreadcrumbs(parentNode, nodes, acc)
		acc.push(parentNode)
	}

	return acc
}
